<template>
    <div>
        <div class="bg-white seminar-box">
            <div class="top-title">
                <h3>Next Seminar</h3>
            </div>
            <div class="seminar-row">
                <ul>
                    <li class="" v-for="(seminar, index) in data.seminars" :key="index">
                        <div class="seminar-logo-img" v-if="index == 0">
                            <img :src="`${$server_url}images/Modules/${seminar.ModuleSmallImage}`"
                                :alt="seminar.ModuleSmallImage">
                        </div>
                        <div class="seminar-text" v-if="index == 0">
                            <a>{{ seminar.ModuleName }}</a>
                            <span class="date">{{ moduleDate(seminar.ModuleStartDate, seminar.SeminarStartTime)
                                }}</span>
                            <span class="location">{{ seminar.ModuleVenue }}</span>
                            <p>Seating is limited and reservations are required</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bg-white seminar-box">
            <div class="top-title">
                <h3>Future Seminars</h3>
            </div>
            <div class="seminar-row">
                <ul>
                    <li class="small-box" v-for="(seminar, index) in data.seminars" :key="index">
                        <div class="seminar-logo-img" v-if="index > 0">
                            <img :src="`${$server_url}images/Modules/${seminar.ModuleSmallImage}`" alt="Image">
                        </div>
                        <div class="seminar-text" v-if="index > 0">
                            <a style="font-size: 17px; line-height: 18px;">{{ seminar.ModuleName }}</a>
                            <span class="date">{{ moduleDate(seminar.ModuleStartDate, seminar.SeminarStartTime)
                                }}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: "seminarSidebar",
    props: {
        // Define the prop name and type
        seminarData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            data: [],
            singleData: {

            }

        }
    },
    watch: {
        seminarData: {
            immediate: true, // Execute the handler immediately on mount
            handler(newData) {
                this.data = newData;
            }
        }
    },
    methods: {
        moduleDate(module, seminar) {
            if (module != null || module != '') {
                return moment(module).format('MMMM DD, Y');
            }
            return moment(seminar).format('MMMM DD, Y')
        },
    }
}
</script>